/**
 * Canonical Tag Hook
 * 
 * Updates the canonical and og:url meta tags during SPA navigation.
 * The initial canonical link is in index.html for SEO/social scrapers.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://launch.dextoro.com';

export function useCanonicalTag() {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = `${BASE_URL}${location.pathname}`;

    // Update existing canonical link (set in index.html)
    const canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (canonicalLink) {
      canonicalLink.href = canonicalUrl;
    }

    // Update og:url meta tag
    const ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
    if (ogUrl) {
      ogUrl.content = canonicalUrl;
    }
  }, [location.pathname]);
}
